import gbAntSelectTwoCascader from "./src/gb-ant-select-two-cascader.vue";
const gbAntSelectTwoCascaderCompenet = function(Vue) {
  Vue.component(gbAntSelectTwoCascader.name, gbAntSelectTwoCascader);
};
export default gbAntSelectTwoCascaderCompenet;
